// extracted by mini-css-extract-plugin
module.exports = {"container":"PhotoGallery_container__WU3Fq","item":"PhotoGallery_item__evIH2"};